import { ISessionSelectorContext, ISessionTreeNode } from "@webapp/sessions/models/session-tree.model";
import { Session } from "@webapp/sessions/models/sessions.model";
import { SessionSelectorUtilsService } from "../session-selector-utils.service";
import { AbstractSessionTreeBuilder } from "./abstract-session-tree-builder";

export class GrandparentAlignmentSessionTreeBuilder extends AbstractSessionTreeBuilder {
  constructor(protected sessionSelectorUtilsService: SessionSelectorUtilsService) {
    super(sessionSelectorUtilsService);
  }

  public buildTree(sessions: Session[], context: ISessionSelectorContext): ISessionTreeNode[] {
    const isSubTreeBuild = Boolean(context.selectedSessionId && context.parentItemSessionId);
    const rootLevelSessions = sessions.filter((s) => !s.parentId || !this.sessionIdMap[s.parentId]).sort(this.sessionSelectorUtilsService.byEndDescAndStartAsc);
    const parentNodes = rootLevelSessions.map((session) => this.createSessionTreeNode(session.id, { sessions, hostSessionId: context.selectedSessionId }));
    const hostNode = this.findHostNode(parentNodes, context.parentItemSessionId);

    return isSubTreeBuild ? [hostNode] : parentNodes;
  }

  protected findHostNode(sessionTree: ISessionTreeNode[], rootSessionId: string): ISessionTreeNode {
    for (const node of sessionTree) {
      let found = null;

      if (node.key === rootSessionId) {
        return node;
      }

      if (node.children.length) {
        found = this.findHostNode(node.children, rootSessionId);
      }

      if (found) {
        return found;
      }
    }

    return null;
  }
}
